export default __webpack_public_path__ + "static/media/polymath.fbd436e8.svg";